var render = function render(){var _vm=this,_c=_vm._self._c;return _c('unicom-layout-pagina',[_c('div',{staticClass:"grande fonte-primaria negrito cor-principal"},[_vm._v(" Oops! :( Erro "+_vm._s(_vm.codigoErro)+" ")]),_c('br'),_c('div',{staticClass:"fonte-primaria subtitulo"},[_vm._v(" "+_vm._s(_vm.objetoErros[_vm.codigoErro])+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }